import React from 'react'
import { ActionDialog } from '@e3dc-react/shell/Elements/Dialog'
import { UpToThreeActions } from '@e3dc-react/shell/Elements/Dialog/ActionDialog/types'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Box } from '@mui/system'
import { useUserSettings } from 'src/Hooks'

type Props = {
  isOpen: boolean
  handleClose: () => void
  dialogActions: UpToThreeActions
}

/* A component that handles Sunmode state when toggling Wallbox Settings */
const LeaveSunModeEnabledDialog = ({ isOpen, dialogActions, handleClose }: Props): JSX.Element | null => {
  const { t } = useCustomTranslation()
  const { userSettings } = useUserSettings()

  if (userSettings.dontShowLeaveSunModeEnabledDialogAgain) return null

  return (
    <ActionDialog
      open={isOpen}
      title={t('systemSettings.wallbox.settings.leave-sunmode-enabled-dialog.title')}
      maxWidth="sm"
      actions={dialogActions}
      onClose={handleClose}
    >
      <Box mt={2}>{t('systemSettings.wallbox.settings.leave-sunmode-enabled-dialog.description')}</Box>
    </ActionDialog>
  )
}

export default LeaveSunModeEnabledDialog
